import { render, staticRenderFns } from "./BaseModalPhoto.vue?vue&type=template&id=fd2c9704&"
import script from "./BaseModalPhoto.vue?vue&type=script&lang=js&"
export * from "./BaseModalPhoto.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports